import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import StyledInput from '../../../app/components/styledComponents/StyledInput';
import Modal from '../../../app/components/modal/Modal';
import { Container, Row, Col } from 'react-bootstrap';
import { usePublishWebsiteMutation } from '../../vendors/vendorsApiSlice';
import StyledButton from '../../../app/components/styledComponents/StyledButton';
import StyledText from '../../../app/components/styledComponents/StyledText';
import useAuth from '../../../hooks/useAuth';
import { useGetOnboardingChecklistQuery } from '../../dashboard/dashboardApiSlice';
import { useNavigate } from 'react-router-dom';
import StyledImage from '../../../app/components/styledComponents/StyledImage';
import DefaultLogo from '../../../assets/Images/logoIcon.jpg';
import { openSubscriptionModal } from '../../../app/services/subscriptionModalSlice';
import { SUBSCRIPTIONSPLANS } from '../../../utils/Constants';

const publishModalTabs = [
  {
    label: 'I have a domain',
  },
  {
    label: 'I need new domain',
    disabled: true,
  },
];

const regex = /^[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;

const DomainRegistrationModal = ({
  open,
  onHide,
  website,
  userDetails,
  refetchUserDetails,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useAuth();
  const { data: preLiveChecks } = useGetOnboardingChecklistQuery(null, {
    refetchOnReconnect: true,
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
  });
  const [publishWebsite, { isLoading: publishing }] =
    usePublishWebsiteMutation();
  const [selectedPublishTab, setSelectedPublishTab] = useState(0);
  const [domain, setDomain] = useState(website ?? '');

  const handlePublishWebsite = async () => {
    if (!preLiveChecks?.subscription)
      return toast.error('Active Subscription Required');
    if (!domain || !regex.test(domain))
      return toast.error('Invalid Domain Name');
    const res = await publishWebsite({
      domain: domain,
      floristId: user.floristId,
    });

    if (!res.error) {
      toast.success('Website Published');
      refetchUserDetails();
    }
  };

  useEffect(() => {
    setDomain(website);
  }, [website]);

  const handleOpenSubscriptionModal = () => {
    dispatch(openSubscriptionModal());
    onHide();
  };

  const handleEditTemplateNavigation = () => {
    navigate('/editTemplate?publish=true');
  };

  return (
    <Modal show={open} onHide={onHide} hideActions>
      {!preLiveChecks ||
      preLiveChecks?.floristSubscriptionDTO?.subType ===
        SUBSCRIPTIONSPLANS.STARTER.toLowerCase() ? (
        <Container fluid>
          <Row>
            <Col>
              <div className="d-flex flex-column align-items-center gap-3">
                <StyledText
                  as="h6"
                  className="m-0"
                  $fontSize="36px"
                  color="headingColor"
                  $fontWeight="600"
                >
                  Upgrade your plan
                </StyledText>
                <StyledImage
                  size="130px"
                  className="my-3 text-muted rounded-circle _image"
                >
                  <img loading="lazy" src={DefaultLogo} alt={''} />
                </StyledImage>
                <StyledText
                  as="h6"
                  className="m-0"
                  $fontSize="18px"
                  color="bodyMedium"
                  $fontWeight="400"
                >
                  Choose a Subscription to access this feature
                </StyledText>
                <StyledButton onClick={() => handleOpenSubscriptionModal()}>
                  <StyledText
                    as="h6"
                    className="m-0"
                    $fontSize="22px"
                    color="white"
                    $fontWeight="600"
                  >
                    Check Out Plans
                  </StyledText>
                </StyledButton>
              </div>
            </Col>
          </Row>
        </Container>
      ) : (
        <Container fluid>
          <Row className="mb-2">
            {publishModalTabs.map((item, index) => (
              <Col
                key={index}
                className="d-flex justify-content-center"
                onClick={() => !item.disabled && setSelectedPublishTab(index)}
              >
                <StyledButton
                  className={`w-100 ${
                    selectedPublishTab === index ? 'active' : ''
                  }`}
                  variant={'outline'}
                  disabled={item.disabled}
                  $fontWeight="600"
                  $fontSize="20px"
                >
                  {item.label}
                </StyledButton>
              </Col>
            ))}
          </Row>
          <Row>
            <Container fluid style={{ minHeight: '200px' }} className="py-4">
              {selectedPublishTab === 0 && (
                <Row>
                  <Col>
                    <div className="d-flex align-items-center mt-2 gap-2">
                      <StyledText
                        as="h6"
                        className="m-0"
                        $fontSize="24px"
                        color="heading"
                        $fontWeight="600"
                      >
                        Domain:
                      </StyledText>

                      <StyledInput
                        newInput
                        value={domain}
                        disabled={
                          userDetails?.floristDTO?.domainRegistered ||
                          !preLiveChecks?.subscription
                        }
                        onChange={(e) => setDomain(e.target.value)}
                        placeholder="flowershop.com"
                      />
                    </div>
                    {!userDetails?.floristDTO?.domainRegistered && (
                      <div className="mt-4">
                        <StyledText
                          as="h6"
                          $fontSize="18px"
                          color="bodyMedium"
                          $fontWeight="400"
                          className="mt-1"
                        >
                          Note: Please confirm if your domain address is
                          correct.
                        </StyledText>
                        <StyledText
                          as="h6"
                          $fontSize="18px"
                          color="bodyMedium"
                          $fontWeight="400"
                          className="mt-1"
                        >
                          <ul>
                            <li>Enter domain name only (Ex: example.com)</li>
                            <li>
                              Do not include subdomains (Ex:
                              subdomain.example.com)
                            </li>
                            <li>
                              Do not include protocols (Ex: http://, https://)
                            </li>
                          </ul>
                        </StyledText>
                      </div>
                    )}
                    {userDetails?.floristDTO?.domainRegistered && (
                      <div className="mt-2">
                        <StyledText
                          as="h6"
                          $fontSize="18px"
                          color="bodyMedium"
                          $fontWeight="400"
                        >
                          Your Domain has been registered with routing from the
                          Boostfloral account.
                          <br />
                          <br />
                          Please update your DNS nameservers in order for your
                          domain to point to the Website. For this please go to
                          your domain provider (for example: Godaddy or Amazon)
                          and update the nameservers in DNS settings with the
                          below-provided nameservers. Please{' '}
                          <StyledButton
                            textButton
                            variant={'outline'}
                            onClick={handleEditTemplateNavigation}
                          >
                            publish
                          </StyledButton>{' '}
                          the website before cutting over DNS.
                          <br />
                          <br />
                          1. ns-1942.awsdns-50.co.uk
                          <br />
                          2. ns-69.awsdns-08.com
                          <br />
                          3. ns-1134.awsdns-13.org
                          <br />
                          4. ns-784.awsdns-34.net
                        </StyledText>
                        <StyledText
                          as="h6"
                          $fontSize="18px"
                          color="bodyMedium"
                          $fontWeight="600"
                          className="mt-5"
                        >
                          Note: Please allow 24hrs to 48hrs for nameservers to
                          propagate to the servers.
                        </StyledText>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
            </Container>
          </Row>
          <Row>
            {!userDetails?.floristDTO?.domainRegistered ? (
              <div className="d-flex gap-3 justify-content-end">
                <StyledButton variant={'outline'} onClick={onHide}>
                  Cancel
                </StyledButton>
                <StyledButton
                  className="text-white"
                  onClick={handlePublishWebsite}
                  loading={publishing}
                  disabled={publishing}
                >
                  Submit
                </StyledButton>
              </div>
            ) : (
              <div className="d-flex gap-3 justify-content-end">
                <StyledButton variant={'outline'} onClick={onHide}>
                  Close
                </StyledButton>
              </div>
            )}
          </Row>
        </Container>
      )}
    </Modal>
  );
};

export default DomainRegistrationModal;
